import React from "react";

export default function DobuleArrowLeft({
  width = "30",
  height = "20",
  stroke = "#6CB2EB",
  fill = "#EFF8FF"
}) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 20"
      width={width}
      height={height}
    >
      <g id="Canvas" fill="none">
        <g id="Back">
          <g id="Vector">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 13.6667 19.035L 0.867027 10L 13.6667 0.96496L 13.6667 19.035ZM 28.6667 19.035L 28.6667 0.96496L 15.867 10L 28.6667 19.035Z"
              transform="translate(0.166626 0)"
              fill={fill}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 13.6667 19.035L 0.867027 10L 13.6667 0.96496L 13.6667 19.035ZM 28.6667 19.035L 28.6667 0.96496L 15.867 10L 28.6667 19.035Z"
              strokeMiterlimit="8"
              transform="translate(0.166626 0)"
              stroke={stroke}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Icons/DoubleArrowLeft.js